

import React, { useEffect, useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import CatEmpleados from '../../../Services/Catalogos/CatEmpleados';
import CatVacaciones from '../../../Services/Catalogos/CatVacaciones';
import DTOVacaciones from '../CatVacaciones/DTO/DTOVacaciones';

const CalendarioSolicitudes: React.FC = () => {
  const [solicitudes, setSolicitudes] = useState<DTOVacaciones[]>([]);
  const [empleadoMap, setEmpleadoMap] = useState<Record<string, string>>({});
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [detalles, setDetalles] = useState<DTOVacaciones[]>([]);

  useEffect(() => {
    const idSupervisor = localStorage.getItem('UserId')?.replace(/"/g, '');

    const interval = setInterval(() => {
      if (idSupervisor) {
        cargarSolicitudes(idSupervisor);
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);

  const cargarSolicitudes = async (idSupervisor: string) => {
    try {
      const empleadosData = await CatEmpleados.GetIdSupervisor(idSupervisor);
      const map: Record<string, string> = {};
      const todasSolicitudes: DTOVacaciones[] = [];

      for (const empleado of empleadosData.data) {
        map[empleado.numEmpleado] = empleado.nombreEmpleado;
        const response = await CatVacaciones.GetAllVacacionesAndDetalle(empleado.numEmpleado);
        if (Array.isArray(response.data)) {
          todasSolicitudes.push(...response.data.filter(s => s.estado.toLowerCase() !== 'eliminado'));
        }
      }

      setSolicitudes(todasSolicitudes);
      setEmpleadoMap(map);
    } catch (error) {
      console.error('Error al cargar solicitudes:', error);
    }
  };

  const formatDate = (date: Date) => date.toISOString().split('T')[0];

  const expandirFechas = (sol: DTOVacaciones): string[] => {
    const fechas: string[] = [];
    const dias = Array.isArray(sol.diasSalteados)
      ? sol.diasSalteados
      : (sol.diasSalteados?.split(',') || []);
    fechas.push(...dias.map(d => d.trim()));

    if (fechas.length === 0 && sol.fechaInicio && sol.fechaFin) {
      const inicio = new Date(sol.fechaInicio);
      const fin = new Date(sol.fechaFin);
      while (inicio <= fin) {
        fechas.push(formatDate(new Date(inicio)));
        inicio.setDate(inicio.getDate() + 1);
      }
    }

    return fechas;
  };

  const obtenerColorPorEstado = (estado: string): string => {
    switch (estado.toLowerCase()) {
      case 'aceptado':
        return '#28a745';
      case 'pendiente':
        return '#fd7e14';
        case 'anticipada':
          return '#fff3cd';
      default:
        return '#6c757d';
    }
  };

  const handleDayClick = (date: Date) => {
    const fechaSeleccionada = formatDate(date);
    const detallesDia = solicitudes.filter(s => {
      const fechas = expandirFechas(s);
      const fechaSolicitud = formatDate(new Date(s.fechaSolicitud));

      return (
        fechas.includes(fechaSeleccionada) ||
        (s.tipoSolicitud?.toLowerCase().includes('solodiaspago') && fechaSolicitud === fechaSeleccionada)
      );
    });

    setSelectedDate(date);
    setDetalles(detallesDia);
  };

  return (
    <>
      <style>
        {`
          .react-calendar {
            width: 100% !important;
            max-width: 500px;
            font-size: 1.3rem;
            border: none;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            border-radius: 16px;
            overflow: hidden;
          }

          .react-calendar__tile {
            position: relative;
            height: 110px !important;
            padding: 0;
          }

          .react-calendar__tile--active {
            background: #007bff !important;
            color: white;
            font-weight: bold;
          }
        `}
      </style>

      <div style={{
        display: 'flex',
        gap: '32px',
        padding: '2rem',
        maxWidth: '1200px',
        margin: '0 auto',
        borderRadius: '16px',
        background: '#fff',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        flexWrap: 'wrap',
        alignItems: 'flex-start'
      }}>
        <div style={{ flex: '1 1 380px', minWidth: '320px' }}>
          <h3 style={{ fontWeight: '600', textAlign: 'center', marginBottom: '1rem' }}>
            📅 Solicitudes
          </h3>

          <Calendar
            onClickDay={handleDayClick}
            tileContent={({ date }) => {
              const fecha = formatDate(date);
              const solicitudesDelDia = solicitudes.filter(s =>
                expandirFechas(s).includes(fecha) ||
                (s.tipoSolicitud?.toLowerCase().includes('solodiaspago') && formatDate(new Date(s.fechaSolicitud)) === fecha)
              );

              if (solicitudesDelDia.length === 0) return null;

              return (
                <div style={{
                  display: 'flex',
                  justifyContent: 'center',
                  flexWrap: 'wrap',
                  gap: '4px',
                  marginTop: '4px'
                }}>
                  {solicitudesDelDia.map((s, index) => (
                    <div
                      key={index}
                      title={`${s.numEmpleado} - ${empleadoMap[s.numEmpleado]} (${s.tipoSolicitud})`}
                      style={{
                        width: '20px',
                        height: '20px',
                        borderRadius: '50%',
                        backgroundColor: obtenerColorPorEstado(s.estado),
                        color: '#000',
                        fontSize: '11px',
                        textAlign: 'center',
                        lineHeight: '20px',
                        fontWeight: 'bold',
                        border: '1px solid #333'
                      }}
                    >
                      {s.tipoSolicitud?.toLowerCase().includes('Soloiaspago')
                        ? '💲'
                        : empleadoMap[s.numEmpleado]?.charAt(0).toUpperCase() || '👤'}
                    </div>
                  ))}
                </div>
              );
            }}
          />
        </div>

        <div style={{
          flex: '2 1 400px',
          maxHeight: '700px',
          overflowY: 'auto',
          paddingRight: '8px',
        }}>
          {selectedDate && (
            <>
              <h5 style={{ fontWeight: '600', marginBottom: '1rem' }}>
                📌 Solicitudes para el {selectedDate.toLocaleDateString()}
              </h5>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                {detalles.map((s, index) => (
                  <li
                    key={index}
                    style={{
                      marginBottom: '20px',
                      padding: '20px',
                      background: '#ffffffcc',
                      borderLeft: `8px solid ${obtenerColorPorEstado(s.estado)}`,
                      borderRadius: '12px',
                      boxShadow: '0 6px 18px rgba(0, 0, 0, 0.1)',
                      fontFamily: '"Segoe UI", Roboto, sans-serif',
                      color: '#333',
                      position: 'relative',
                      overflow: 'hidden',
                    }}
                  >
                    <div style={{ fontSize: '14px', color: '#888' }}>ID #{s.id}</div>

                    <div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '6px', color: '#222' }}>
                      👤 {s.numEmpleado} — {empleadoMap[s.numEmpleado] || s.nombre}
                    </div>

                    <div style={{ fontSize: '14px', marginBottom: '4px' }}>
                      <span style={{ fontWeight: 600 }}>📌 Tipo:</span> {s.tipoSolicitud}
                    </div>

                    <div style={{ fontSize: '14px', marginBottom: '4px' }}>
                      <span style={{ fontWeight: 600 }}>📅 Días:</span>{' '}
                      {expandirFechas(s).length > 0
                        ? expandirFechas(s).join(', ')
                        : `Solicitud de pago realizada el ${new Date(s.fechaSolicitud).toLocaleDateString()}`}
                    </div>

                    {s.observaciones && (
                      <div style={{ fontSize: '14px', marginBottom: '4px' }}>
                        <span style={{ fontWeight: 600 }}>📝 Observaciones:</span> {s.observaciones}
                      </div>
                    )}

                    {s.comentario && (
                      <div style={{ fontSize: '14px', marginBottom: '4px' }}>
                        <span style={{ fontWeight: 600 }}>💬 Comentario:</span> {s.comentario}
                      </div>
                    )}

                    <div style={{ fontSize: '14px', marginBottom: '10px' }}>
                      <span style={{ fontWeight: 600 }}>📌 Estado:</span>{' '}
                      <span
                        style={{
                          padding: '2px 8px',
                          borderRadius: '10px',
                          backgroundColor: (() => {
                            const estado = s.estado.toLowerCase();
                            if (estado === 'aceptado') return '#28a74533';
                            if (estado === 'pendiente') return '#fd7e1433';
                            return '#e0e0e0';
                          })(),
                          color: (() => {
                            const estado = s.estado.toLowerCase();
                            if (estado === 'aceptado') return '#28a745';
                            if (estado === 'pendiente') return '#fd7e14';
                            return '#6c757d';
                          })(),
                          fontWeight: 'bold',
                          fontSize: '13px',
                        }}
                      >
                        {s.estado}
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default CalendarioSolicitudes;
